import { render, staticRenderFns } from "./UnrankedPortfolioConfirmationComponent.vue?vue&type=template&id=369eec5f&scoped=true"
import script from "./UnrankedPortfolioConfirmationComponent.vue?vue&type=script&lang=js"
export * from "./UnrankedPortfolioConfirmationComponent.vue?vue&type=script&lang=js"
import style0 from "./UnrankedPortfolioConfirmationComponent.vue?vue&type=style&index=0&id=369eec5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369eec5f",
  null
  
)

export default component.exports